import { GamesService } from '../../../services/games/games.service';
import { map, tap } from 'rxjs/operators';
import { NEVER, Observable, of } from 'rxjs';
import { Component, OnInit, effect, inject, input } from '@angular/core';
import { GameSearchService } from '../../../services/games/game-search.service';
import { LastPlayedGamesService } from '../../../services/games/last-played-games.service';
import { FavoriteGamesService } from '../../../services/games/favorite-games.service';
import { Router } from '@angular/router';
import { TranslatePipe } from '../../../services/translation/translate.pipe';
import { SafePipe } from 'ngx-unificator/pipes';
import { SkeletonComponent } from '../skeleton/skeleton.component';
import { FittextDirective } from '../../directives/fit-text.directive';
import { GamePreviewComponent } from '../game-preview/game-preview.component';
import { NgClass, AsyncPipe } from '@angular/common';
import { IgnoreHtmlTagsPipe } from 'ngx-unificator/pipes'

export interface GameListConfig {
  filter?: any;
  title?: string;
  link?: string;
  btnName?: string;
  gameList?: any[];
  type?: 'favorite' | 'last-played' | 'tournament';
  hideTitle?: boolean;
}

@Component({
    selector: 'app-game-list',
    templateUrl: './game-list.component.html',
    styleUrls: ['./game-list.component.scss'],
    imports: [NgClass, GamePreviewComponent, FittextDirective, SkeletonComponent, AsyncPipe, SafePipe, IgnoreHtmlTagsPipe, TranslatePipe]
})
export class GameListComponent implements OnInit {
  private _games = inject(GamesService);
  private _lastPlayed = inject(LastPlayedGamesService);
  private _favorite = inject(FavoriteGamesService);
  private _router = inject(Router);
  private _search = inject(GameSearchService);

  private _config: GameListConfig;

  public config = input<GameListConfig>({});
  public list$: Observable<any> = NEVER;
  public showMore: boolean = null;
  public isEmpty: boolean = null;

  constructor() {
    effect(() => {
      this._config = this.config();
      this.list$ = this._reducerGameList();
    })
  }

  ngOnInit() {
  }

  get onGetConfig(): GameListConfig {
    return this._config;
  }

  /**
   * Return game list by game type: default, last-played, favorite
   * @returns
   */
  private _reducerGameList(): Observable<any> {
    let list: Observable<any>;
    switch (this._config.type) {
      case 'favorite':
        list = this._favorite.getMappedGameList().pipe(
          map(e => {
            e.gameList = e.gameList || [];
            e.gameList = e.gameList.slice(0, this._config.filter.limit);
            return e;
          })
        );
        break;
      case 'last-played':
        list = this._lastPlayed.getMappedGameList().pipe(
          map(e => {
            e.gameList = e.gameList || [];
            e.gameList = e.gameList.slice(0, this._config.filter.limit);
            return e;
          })
        );
        break;
      case 'tournament':
        list = of(this._config).pipe(
          map(e => {
            e.gameList = this._games.gameListMapper(this._config?.gameList?.slice(0, this._config.filter.limit) || []);
            return e;
          })
        );
        break;
      default:
        list = this._games.list(this._config?.filter);
        break;
    }
    return list.pipe(
      tap((e: any) => {
        this._resolveGameSize(e.gameList);
      })
    );
  }

  /**
   * Hide link more if gameList size < config.filter.limit
   * or hide all list if gameList size === 0
   */
  private _resolveGameSize(gameList: any[]) {
    if (gameList.length === this._config?.filter?.limit) {
      this.showMore = true;
    }
    if (!gameList.length && this._config?.type !== 'tournament') {
      this.isEmpty = true;
    }
  }

  async goToRoute() {
    if (this._search.showPopup) {
      this._search.togglePopup();
    }
    await this._router.navigateByUrl(this._config.link);
  }

}
